<template>
  <section
    class="layout-pt-lg layout-pb-lg"
    :style="`background-color: var(--c-${vars.backgroundColor}); z-index: 1 !important;`"
  >
    <BlockSymbol
      v-if="company.company_key === 'copeandco'"
      :position-text="String(vars?.blockPositionText || '')"
      :block-color="String(vars?.blockColor || '')"
      :block-opacity="Number(vars?.blockOpacityNumber || 1)"
      block-symbol="&"
    />

    <BlockSymbol
      v-else
      :position-text="String(vars?.blockPositionText || '')"
      :block-color="String(vars?.blockColor || '')"
      :block-opacity="Number(vars?.blockOpacityNumber || 1)"
      :company-key="company?.company_key"
    />
    <!-- Header with logo and "View All Blogs" button -->
    <div class="container tw-z-10">
      <div class="row tw-px-3 lg:tw-flex lg:tw-flex-row lg:tw-items-center lg:tw-justify-between">
        <div class="!tw-w-auto" v-html="vars.titleHtml" />
        <nuxt-link
          v-if="company.company_key !== 'keystonepmc'"
          to="/blogs"
          :external="true"
          class="n-quaternary outlined tw-hidden !tw-w-auto tw-items-center tw-gap-2 lg:tw-flex"
        >
          VIEW ALL BLOGS
          <span v-if="vars.buttonTypeText?.toString().includes('secondary icon')" class="btn-arrow">
            <svg width="23" height="9" viewBox="0 0 23 9" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M22.3536 4.85355C22.5488 4.65829 22.5488 4.34171 22.3536 4.14645L19.1716 0.964466C18.9763 0.769204 18.6597 0.769204 18.4645 0.964466C18.2692 1.15973 18.2692 1.47631 18.4645 1.67157L21.2929 4.5L18.4645 7.32843C18.2692 7.52369 18.2692 7.84027 18.4645 8.03553C18.6597 8.2308 18.9763 8.2308 19.1716 8.03553L22.3536 4.85355ZM0 4.5V5H22V4.5V4H0V4.5Z"
                fill="var(--c-text_primary)"
              />
            </svg>
          </span>
        </nuxt-link>

        <nuxt-link
          v-if="company.company_key === 'keystonepmc'"
          v-for="(button, index) in buttons"
          :key="`takeaction-button-${index}`"
          :external="true"
          :to="button.link"
          :class="`n-${button.type} tw-hidden !tw-w-auto tw-items-center tw-gap-2 lg:tw-flex`"
          >{{ button.label }}</nuxt-link
        >
      </div>

      <div
        class="relative mt-60 md:mt-40 sm:mt-20 js-section-slider tw-z-10 lg:!tw-hidden"
        data-anim="slide-left delay-1"
        data-gap="30"
        data-slider-cols="xl-3 lg-2 md-1 sm-1 base-1"
      >
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="(blog, index) in blogs" :key="`latestblogs-blog-${index}`">
            <Theme7BlogsBlogCard
              :button-type-text="vars.buttonTypeText"
              :text-color="vars.textColor"
              :blog="blog"
              :version="company.company_key === 'keystonepmc' ? 'v5' : 'v1'"
              :index="index"
              :component="component"
            />
          </div>
        </div>

        <div
          class="d-flex mt-60 md:mt-30 max-lg:tw-items-center max-lg:tw-justify-center"
          v-if="company.company_key !== 'keystonepmc'"
        >
          <button
            class="sliderNav -prev js-prev n-link !tw-bg-transparent !tw-text-white"
            style="border-color: white !important"
          >
            <i class="icon-left-arrow"></i>
          </button>
          <button
            style="border-color: white !important"
            class="sliderNav -next ml-20 js-next n-link !tw-bg-transparent !tw-text-white"
          >
            <i class="icon-right-arrow"></i>
          </button>
        </div>

        <div
          class="d-flex mt-60 md:mt-30 max-lg:tw-items-center max-lg:tw-justify-center"
          v-if="company.company_key === 'keystonepmc'"
        >
          <button class="sliderNav -prev js-prev n-link">
            <i class="icon-left-arrow"></i>
          </button>
          <button class="sliderNav -next ml-20 js-next n-link">
            <i class="icon-right-arrow"></i>
          </button>
        </div>
      </div>
      <div class="tw-mt-10 lg:tw-hidden" v-if="company.company_key !== 'keystonepmc'">
        <nuxt-link to="/blogs" :external="true" class="n-quaternary outlined tw-mt-10">VIEW ALL BLOGS</nuxt-link>
      </div>

      <div class="flex flex-col tw-mt-20 lg:tw-hidden">
        <h2 class="text-white text-36 uppercase fw-600 blogs-box-text">{{ vars.titleText }}</h2>

        <div class="flex flex-col mt-30">
          <nuxt-link
            v-for="(button, index) in buttons"
            :key="`takeaction-button-${index}`"
            :external="true"
            :to="button.link"
            :class="`n-${button.type} tw-w-full md:tw-w-auto`"
            >{{ button.label }}</nuxt-link
          >
        </div>
      </div>

      <div class="row y-gap-60 tw-hidden lg:tw-flex">
        <!-- Main Column - Featured Blog Posts -->
        <div class="col-lg-8">
          <div class="row">
            <!-- Featured Blog Post (Large) -->
            <div data-anim="slide-up delay-1" class="col-12">
              <Theme7BlogsBlogCard
                :blog="blogs[0]"
                :index="0"
                :version="company.company_key === 'keystonepmc' ? 'v5' : 'v1'"
                :button-type-text="vars.buttonTypeText"
                :text-color="vars.textColor"
                :is-large-img="true"
                :component="component"
              />
            </div>
          </div>

          <div class="flex flex-col tw-mt-20">
            <h2 class="text-36 uppercase fw-600" :style="{ color: `var(--c-${vars.textColor})` }">
              {{ vars.titleText }}
            </h2>

            <div class="flex flex-col tw-mt-12">
              <nuxt-link
                v-for="(button, index) in buttons"
                :key="`takeaction-button-${index}`"
                :to="button.link"
                :class="`n-${button.type} tw-w-full md:tw-w-auto`"
                :external="true"
                >{{ button.label }}</nuxt-link
              >
            </div>
          </div>
        </div>

        <!-- Sidebar Column -->
        <div class="col-lg-4">
          <!-- Blog Card 1 -->
          <div data-anim="slide-up delay-1" class="mb-40">
            <Theme7BlogsBlogCard
              :button-type-text="vars.buttonTypeText"
              :text-color="vars.textColor"
              :blog="blogs[1]"
              :index="1"
              :component="component"
              :version="company.company_key === 'keystonepmc' ? 'v5' : 'v1'"
            />
          </div>

          <!-- Blog Card 2 -->
          <div data-anim="slide-up delay-2" class="mb-40">
            <Theme7BlogsBlogCard
              :button-type-text="vars.buttonTypeText"
              :text-color="vars.textColor"
              :blog="blogs[2]"
              :index="2"
              :component="component"
              :version="company.company_key === 'keystonepmc' ? 'v5' : 'v1'"
            />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { mapState } from 'pinia';
import type { Component } from '~/types';
import indexGlobal from '~/mixins/index.global';
import { BlogsMixin } from '~/units/blogs/mixins/blogs.mixin';
import { ComponentMixin } from '~/mixins/component.mixin';
import { useBlogsStore } from '~/units/blogs/store';
import { useWebsiteStore } from '~/units/website/store';
import { ROUTES } from '~/constants/ui.constants';
import Loader from '~/components/common/Loader.vue';
import BlockSymbol from '~/components/common/BlockSymbol.vue';
export default defineNuxtComponent({
  name: 'Theme7BlogsBox',

  mixins: [BlogsMixin, indexGlobal, ComponentMixin],

  components: {
    Loader,
    BlockSymbol,
  },

  data() {
    return {
      swiper: null,
      canPaginateBack: true,
      canPaginateNext: true,

      variants: {
        v1: 'v1',
        v2: 'v2',
      },
    };
  },

  async setup(props: { component: Component }) {
    const blogsStore = useBlogsStore();
    await blogsStore.fetchBlogsInPage(props.component);
  },

  computed: {
    ...mapState(useWebsiteStore, ['sidebarComponents','company']),
    ROUTES() {
      return ROUTES;
    },
    cards() {
      return this.groupedVariables.cards;
    },
    buttons() {
      return this.groupedVariables.buttons;
    },
  },

  methods: {
    onSwiper(swiper) {
      this.swiper = swiper;
    },

    onSlideChange() {
      if (!this.swiper) return;
      const isAtStart = this.swiper.isBeginning;
      const isAtEnd = this.swiper.isEnd;
      if (isAtStart) this.canPaginateBack = false;
      else this.canPaginateBack = true;
      if (isAtEnd) this.canPaginateNext = false;
      else this.canPaginateNext = true;
    },
  },
  mounted() {
    this.onSlideChange();
  },
});
</script>
<style scoped>
.block {
  font-size: 32rem !important;
  font-weight: 700 !important;
  color: var(--c-secondary);
  line-height: 0.8;
  z-index: -1;
  margin: 0;
  padding: 0;
  position: absolute;
  bottom: 0 !important;
  left: -80px !important;
}
</style>
